import React from "react";
import "./App.css";
import "./Styles/UploadFile.css";
import "bootstrap/dist/css/bootstrap.min.css";
import LinearStepper from "./Components/LinearStepper";
//import { CssBaseline, Container, Paper, Box } from "@material-ui/core";
import { Container } from "react-bootstrap";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import Banner from "./Components/Banner";
import "./Styles/App.scss";

function App() {
  return (
    <>
      <Navbar />
      <div className="container">
        <div className="row">
          <div className="col-lg-9">
            <LinearStepper />
          </div>
          <div className="col-lg-3">
            <Banner />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default App;
